import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';
import { ModalViewEvent } from 'pf-frontend-common/src/module/modal/view.event';
import { ModalServiceInterface } from 'pf-frontend-common/src/service/modal/service.interface';

import { DataStore } from 'common/module/data/store';
import { MyAccountConfirmationTemplatePropsInterface } from 'common/module/my-account/confirmation/template-props.interface';
import { MyAccountStatechartEvent } from 'common/module/my-account/statechart.event';
import { StatechartStoreInterface } from 'common/module/statechart/store.interface';

import { MyAccountConfirmationOptionInterface } from './option.interface';

export class MyAccountConfirmationViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: MyAccountConfirmationTemplatePropsInterface;

  /**
   * Constructor
   */
  constructor(
    eventEmitter: EventEmitterInterface,
    private myAccountStatechartStore: StatechartStoreInterface,
    private modalService: ModalServiceInterface
  ) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(options: MyAccountConfirmationOptionInterface): void {
    this.state = {
      title: options.title,
      description: options.description,
      onClickApprove: this.onClickApprove,
      onClickReject: this.onClickReject,
    };

    this.setState(this.state);

    // Attach observers
    this.observers();
  }

  /**
   * Click no button
   */
  private onClickReject = (): void => {
    this.myAccountStatechartStore.transit({
      event: MyAccountStatechartEvent.rejectDeleting,
      payload: {},
    });
  };

  /**
   * Click yes button
   */
  private onClickApprove = (e: Event): void => {
    e.preventDefault();

    this.myAccountStatechartStore.transit({
      event: MyAccountStatechartEvent.approveDeleting,
      payload: {},
    });
  };

  /**
   * Attach observers
   */
  private observers(): void {
    this.modalService.getEventEmitter().addListener(ModalViewEvent.close, this.onCloseModal);
  }

  /**
   * Close event
   */
  private onCloseModal = (): void => {
    this.myAccountStatechartStore.transit({
      event: MyAccountStatechartEvent.rejectDeleting,
      payload: {},
    });
  };
}
